module.exports = __webpack_public_path__ + "img/header.10563c70.png";